var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBridge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(-4 -9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M57.54,9.5H52.16a2.458,2.458,0,0,0-2.46,2.46V25.45H14.79V11.96A2.458,2.458,0,0,0,12.33,9.5H6.46A2.458,2.458,0,0,0,4,11.96V52.04A2.458,2.458,0,0,0,6.46,54.5h5.87a2.458,2.458,0,0,0,2.46-2.46V35.14h4.07a1.2,1.2,0,0,0,1.2-1.2V32.9H44.43v1.04a1.2,1.2,0,0,0,1.2,1.2H49.7v16.9a2.458,2.458,0,0,0,2.46,2.46h5.38A2.458,2.458,0,0,0,60,52.04V11.96A2.458,2.458,0,0,0,57.54,9.5ZM12.79,52.04a.465.465,0,0,1-.46.46H6.46A.465.465,0,0,1,6,52.04V11.96a.465.465,0,0,1,.46-.46h5.87a.465.465,0,0,1,.46.46V52.04Zm5.27-18.9H14.79V27.45h3.27v5.69Zm2-2.24V27.45H28.7L23.08,30.9Zm6.84,0,5.34-3.27,5.28,3.27Zm17.53,0H41.32l-5.56-3.45h8.67V30.9Zm5.27,2.24H46.43V27.45H49.7ZM58,52.04a.465.465,0,0,1-.46.46H52.16a.465.465,0,0,1-.46-.46V42.88h2.15v6.53a1,1,0,0,0,2,0V42.88H58Zm0-11.16H54.87c-.01,0-.01-.01-.02-.01l-.01.01H51.7V34.61H58Zm0-8.27H55.85V14.39a1,1,0,1,0-2,0V32.61H51.7V11.96a.465.465,0,0,1,.46-.46h5.38a.465.465,0,0,1,.46.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M10.39,14.39V49.41a1,1,0,0,1-2,0V14.39a1,1,0,1,1,2,0ZM56.44,37.74a1.59,1.59,0,1,1-1.59-1.58A1.586,1.586,0,0,1,56.44,37.74Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.3d71d58f1f7fe9d7cabbbdce3165f8d9.svg";
export { ForwardRef as ReactComponent };